var exports = {
  "z": "ChannelName.module__root___OFM4SE",
  "Z": "ChannelName.module__emoji___OFM4SE",
};

module.exports = exports;
